@if (showHeader$ | async) {
  <rma-site-header
    [basicHeader]="basicHeader$ | async"
    [fullWidthHeader]="fullWidthHeader$ | async"
    [showMarketingNav]="showMarketingNav$ | async"
    [renownedBranding]="renownedBranding$ | async"
    [loginHeader]="loginHeader$ | async"
  />
}
<section
  class="rma-content"
  [class.!pt-0]="(showHeader$ | async) === false"
  [class.scroll-smooth]="scrollSmooth"
  [class.renowned]="renownedBranding$ | async"
>
  <div class="rma-loader" [class.visible]="isLoading" [class.invisible]="!isLoading">
    @if (isLoading) {
      <mat-spinner />
    }
  </div>

  <router-outlet />

  @if (showFooter$ | async) {
    <rma-footer class="nc-container" />
  }
</section>
